/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getPosts.defs.js'
export { main as default } from './getPosts.defs.js'
